import React, { Component } from "react";
import Button from "@material-ui/core/Button";
import Drawer from "@material-ui/core/Drawer";
import { connect } from "react-redux";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Input from "@material-ui/core/Input";
import ChatUserList from "components/chatPanel/ChatUserList";
import conversationList from "../data/conversationList";
import users from "../data/chatUsers";
import SearchBox from "components/SearchBox/index";
import CustomScrollbars from "util/CustomScrollbars";
import "./style.css";
import ContactList from "components/chatPanel/ContactList/index";

//form imports
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import IconButton from "@material-ui/core/IconButton";
import Add from "@material-ui/icons/Add";
import axios from "axios";
import AddIcon from "@material-ui/icons/Add";
import MoreVertIcon from "@material-ui/icons/MoreVert";

//menu
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import FilterListIcon from "@material-ui/icons/FilterList";

//usermagment
import User from "./User";
import Refund from "./Refund";
import Cutomer from "./Cutomer";
//date time picker
import { DateTimePicker } from "material-ui-pickers";
import InputAdornment from "@material-ui/core/InputAdornment";

//dropzon
import Dropzone from "react-dropzone";
//icons
import PrintIcon from "@material-ui/icons/Print";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import UpdateIcon from "@material-ui/icons/Update";
import GetAppIcon from "@material-ui/icons/GetApp";
import SearchIcon from "@material-ui/icons/Search";
import Divider from "@material-ui/core/Divider";
import BeenhereIcon from "@material-ui/icons/Beenhere";

//notification and spinner
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import Backdrop from "@material-ui/core/Backdrop";
import IntlMessages from "util/IntlMessages";
import CircularProgress from "@material-ui/core/CircularProgress";

import { withStyles } from "@material-ui/styles";

import Swal from "sweetalert2";
import { debounce } from "@material-ui/core";

const styles = (theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: "#fff",
  },
});

class ChatPanel extends Component {
  filterContact = (userName) => {
    if (userName === "") {
      return users.filter((user) => !user.recent);
    }
    return users.filter(
      (user) =>
        !user.recent &&
        user.name.toLowerCase().indexOf(userName.toLowerCase()) > -1
    );
  };
  filterUsers = (userName) => {
    if (userName === "") {
      return users.filter((user) => user.recent);
    }
    return users.filter(
      (user) =>
        user.recent &&
        user.name.toLowerCase().indexOf(userName.toLowerCase()) > -1
    );
  };

  resolveAfter2Seconds = () => {
    return new Promise((resolve) => {
      if (this.state.files.length !== 0) {
        this.state.files.map((value, index, { length }) => {
          let file = value;
          let reader = new FileReader();
          reader.onloadend = (file) => {
            this.state.base64files[index] = reader.result;
          };
          reader.readAsDataURL(file);
          if (index + 1 === length) {
            setTimeout(() => {
              resolve("resolved");
            }, 1000);
          }
        });
      }
    });
  };

  handlSubmit = async (e) => {
    e.preventDefault();
    if (this.state.files.length !== 0) {
      await this.resolveAfter2Seconds();
    }

    const data = {
      user_id: JSON.parse(localStorage.getItem("UserData")).id,
      datetime: this.state.selectedDate,
      customerobj: this.state.customerobj,
      supplierobj: this.state.supplierobj,
      adult: this.state.adult,
      kids: this.state.kids,
      infants: this.state.infants,
      adlPurchase: this.state.adlPurchase,
      kidPurchase: this.state.kidPurchase,
      infPurchase: this.state.infPurchase,
      adlSell: this.state.adlSell,
      kidSell: this.state.kidSell,
      infSell: this.state.infSell,
      purchase: this.state.purchase,
      sell: this.state.sell,
      discount: this.state.discount,
      commission: this.state.commission,
      extra: this.state.extra,
      paid: this.state.paid,
      cb: this.state.cb,
      scc: this.state.scc,
      remark: this.state.remark,
      currency: this.state.currency,
      files: this.state.base64files,
      total: this.state.total,
      editstatus: this.state.editstatus,
      editID: this.state.editID,
    };
    this.setState({ openbackdrop: true });
    axios
      .put("api/sale/" + this.state.selectedSectionId, data)
      .then((res) => {
        if (this.state.selectedTabIndex === 0) {
          this.setState({ url: "api/getsale" });
          this.getSales();
        } else {
          this.setState({ refurl: "api/getrefund" });
          this.getRefund();
        }

        this.setState({ openbackdrop: false });
        NotificationManager.success(
          <IntlMessages id="notification.successMessage" />,
          <IntlMessages id="notification.titleHere" />
        );
      })
      .catch((err) => {
        this.setState({ openbackdrop: false });
        NotificationManager.error(
          <IntlMessages id="notification.errorMessage" />,
          <IntlMessages id="notification.titleHere" />
        );
      });
  };

  Communication = () => {
    const { selectedUser } = this.state;
    // const {conversationData} = conversation;
    const handleDateChange = (date) => {
      this.setState({ selectedDate: date });
    };

    //dropzon
    const files = this.state.files.map((file) => (
      <li style={{ display: "inline" }} key={file.name}>
        {file.name + "   |   "}
      </li>
    ));

    const addcustomer = () => {
      if (this.state.customaer !== null) {
        const data = {
          name: this.state.customaer,
        };
        axios
          .post("api/customer", data)
          .then((res) => {
            this.setState({ customerobj: res.data });
            this.setState({ showspinner: false });
            NotificationManager.success(
              <IntlMessages id="notification.successMessage" />,
              <IntlMessages id="notification.titleHere" />
            );
          })
          .catch((err) => {
            this.setState({ showspinner: false });
            NotificationManager.error(
              <IntlMessages id="notification.errorMessage" />,
              <IntlMessages id="notification.titleHere" />
            );
          });
      } else {
        alert("type the customer name !");
      }
    };

    const addSupplier = () => {
      if (this.state.supplier !== null) {
        const data = {
          name: this.state.supplier,
        };
        axios
          .post("api/supplier", data)
          .then((res) => {
            this.setState({ supplierobj: res.data });
            this.setState({ showspinner: false });
            NotificationManager.success(
              <IntlMessages id="notification.successMessage" />,
              <IntlMessages id="notification.titleHere" />
            );
          })
          .catch((err) => {
            this.setState({ showspinner: false });
            NotificationManager.error(
              <IntlMessages id="notification.errorMessage" />,
              <IntlMessages id="notification.titleHere" />
            );
          });
      } else {
        alert("type the customer name !");
      }
    };

    const countTotal = () => {
      this.setState({ total: null });
      var adultRes = this.state.adult * this.state.adlSell;
      var kidsRes = this.state.kids * this.state.kidSell;
      var infRes = this.state.infants * this.state.infSell;
      var sellRes = adultRes + kidsRes + infRes;
      var finalRes = sellRes - this.state.discount;
      var exresult = Number(finalRes) + Number(this.state.extra);
      this.setState({ total: exresult });

      this.setState({ commission: null });
      var adultResult =
        (this.state.adlSell - this.state.adlPurchase) * this.state.adult;
      var kidResult =
        (this.state.kidSell - this.state.kidPurchase) * this.state.kids;
      var infantResult =
        (this.state.infSell - this.state.infPurchase) * this.state.infants;
      var result = adultResult + kidResult + infantResult;
      this.setState({ commission: result });
    };

    const aprroveEdit = (id) => {

      axios
        .get("api/aprrove/" + id)
        .then((res) => {
          if (this.state.selectedTabIndex === 0) {
            this.setState({ url: "api/getsale" });
            this.getSales();
          } else {
            this.setState({ refurl: "api/getrefund" });
            this.getRefund();
          }
          this.setState({ editSale: 0 });
          NotificationManager.success(
            "Edit approved !",
            <IntlMessages id="notification.titleHere" />
          );
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    };

    const aprrovePayment = (id, sale_no) => {
      Swal.fire({
        title:
          "Are you sure you want to approve (" +
          this.state.paid +
          " " +
          this.state.currency +
          ") for sale No " +
          sale_no +
          " ?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, Approve it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .get("api/approvepayment/" + id)
            .then((res) => {
              this.setState({ url: "api/getsale" });
              this.getSales();
              this.setState({ provepay: 0 });
              NotificationManager.success(
                <IntlMessages id="notification.successMessage" />,
                <IntlMessages id="notification.titleHere" />
              );
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            });
        }
      });
    };
    const deletSell = (id) => {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
            .delete("api/sale/" + id)
            .then((res) => {
              if (this.state.selectedTabIndex === 0) {
                this.setState({ url: "api/getsale" });
                this.getSales();
              } else {
                this.setState({ refurl: "api/getrefund" });
                this.getRefund();
              }
              NotificationManager.success(
                <IntlMessages id="notification.successMessage" />,
                <IntlMessages id="notification.titleHere" />
              );
            })
            .catch((err) => {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Something went wrong!",
              });
            });
        }
      });
    };

    const editSale = (id) => {
      const data = {
        user_id: JSON.parse(localStorage.getItem("UserData")).id,
        sale_id: id,
      };

      if (JSON.parse(localStorage.getItem("UserData")).usertype === 3) {
        if (this.state.editstatus === 0) {
        
          this.setState({
            isReadonly: false,
          });
          NotificationManager.success(
            "Edit is now available",
            <IntlMessages id="notification.titleHere" />
          );

        } else {
          Swal.fire({
            title: "Are you sure?",
            text: "Do you want to send edit request for admin!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, send request!",
          }).then((result) => {
            if (result.isConfirmed) {
              axios
                .post("api/editrequest", data)
                .then((res) => {
                  if (res.data.message === "success") {
                    if (this.state.selectedTabIndex === 0) {
                      this.setState({ url: "api/getsale" });
                      this.getSales();
                    } else {
                      this.setState({ refurl: "api/getrefund" });
                      this.getRefund();
                    }
                    NotificationManager.success(
                      "Request succefully Sent !",
                      <IntlMessages id="notification.titleHere" />
                    );
                  } else {
                    NotificationManager.error(
                      "Request allready sent!",
                      <IntlMessages id="notification.titleHere" />
                    );
                  }
                })
                .catch((err) => {
                  console.log(err);
                  Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: "Something went wrong!",
                  });
                });
            }
          });
        }
      } else {
        if(JSON.parse(localStorage.getItem("UserData")).id ===this.state.selectedUser.user.id){
          this.setState({
            isReadonly: false,
          });
          NotificationManager.success(
            "Edit is now available",
            <IntlMessages id="notification.titleHere" />
          );
        }else{
          NotificationManager.success(
            "Only you can approve edit as manager !",
            <IntlMessages id="notification.titleHere" />
          );
        }
      }
    };

    return (
      <div className="chat-main">
        <div className="chat-main-header">
          <IconButton
            className="d-block d-xl-none chat-btn"
            aria-label="Menu"
            onClick={this.onToggleDrawer.bind(this)}
          >
            <i className="zmdi zmdi-comment-text" />
          </IconButton>
          <div className="chat-main-header-info">
            <div className="chat-avatar mr-2">
              <div className="chat-avatar-mode">
                <img
                  src="https://via.placeholder.com/150x150"
                  className="rounded-circle size-60"
                  alt=""
                />

                <span className={`chat-mode ${selectedUser.status}`} />
              </div>
            </div>

            <div className="chat-contact-name">{selectedUser.serial_no}</div>
          </div>

          {JSON.parse(localStorage.getItem("UserData")).usertype !== 3 &&
          this.state.editsale === 1 ? (
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                aprroveEdit(this.state.editID);
              }}
            >
              Pleas Aprove edit ...
            </Button>
          ) : (
            ""
          )}

          {JSON.parse(localStorage.getItem("UserData")).usertype === 3 &&
          this.state.editstatus === 0 ? (
            <Button variant="contained" color="#28a745">
              Edit approved ...
            </Button>
          ) : (
            ""
          )}

          {JSON.parse(localStorage.getItem("UserData")).usertype !== 3 &&
          this.state.provepay === 1 ? (
            this.state.paid !==null ?(
              <IconButton
              color="primary"
              aria-label="upload picture"
              component="span"
              onClick={() => {
                aprrovePayment(
                  this.state.selectedSectionId,
                  selectedUser.serial_no
                );
              }}
              title="Approve Payment"
            >
              <BeenhereIcon style={{ color: "#ff9800" }} />
            </IconButton>
            ):''
            
          ) : (
            ""
          )}

          <IconButton
            color="primary"
            aria-label="upload picture"
            component="span"
            onClick={() => {
              deletSell(this.state.selectedSectionId);
            }}
          >
            <DeleteIcon />
          </IconButton>

          <IconButton
            color="primary"
            aria-label="upload picture"
            component="span"
            onClick={() => {
              editSale(this.state.selectedSectionId);
            }}
          >
            <EditIcon />
          </IconButton>
        </div>

        <CustomScrollbars
          className="chat-list-scroll scrollbar content-form-style"
          style={{
            height:
              this.props.width >= 1200
                ? "calc(100vh - 120px)"
                : "calc(100vh - 180px)",
          }}
        >
          <form className="p-5" onSubmit={this.handlSubmit}>
            <div className="row">
              <div className="col-md-5">
                <DateTimePicker
                  fullWidth
                  autoOk
                  showTabs={false}
                  autoSubmit={false}
                  disableFuture
                  value={this.state.selectedDate}
                  onChange={handleDateChange}
                  leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                  rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <i className="zmdi zmdi-alarm" />
                      </InputAdornment>
                    ),
                  }}
                />
              </div>

              <di className="col-md-1"></di>
              <di className="col-md-2"></di>
              <di className="col-md-1"></di>
              <div className="col-md-3 radioBtn">
                <div
                  className="btn-group form-group float-right"
                  role="group"
                  aria-label="Basic radio toggle button group"
                >
                  <input
                    type="radio"
                    className="btn-check form-control"
                    name="curency"
                    id="btnradio1"
                    onChange={(e) =>
                      this.setState({ currency: e.target.value })
                    }
                    checked={this.state.currency === "AFN"}
                    value="AFN"
                  />
                  <label
                    className="btn btn-outline-primary"
                    htmlFor="btnradio1"
                  >
                    AFN
                  </label>
                  <input
                    type="radio"
                    className="btn-check form-control"
                    name="curency"
                    id="btnradio2"
                    onChange={(e) =>
                      this.setState({ currency: e.target.value })
                    }
                    checked={this.state.currency === "USD"}
                    value="USD"
                  />
                  <label
                    className="btn btn-outline-primary"
                    htmlFor="btnradio2"
                  >
                    USD
                  </label>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-5">
                {this.state.type === 2 ? (
                  <div className="row">
                    <div className="col-md-12 pt-3">
                      <Autocomplete
                        id="combo-box-demo"
                        variant="outlined"
                        size="small"
                        options={this.state.supplierList}
                        getOptionLabel={(option) => option.name}
                        value={this.state.supplierobj}
                        onChange={(event, newValue) =>
                          this.setState({ supplierobj: newValue })
                        }
                        fullWidth={true}
                        InputProps={{
                          readOnly: this.state.isReadonly,
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Supplier"
                            variant="outlined"
                            onChange={(e) =>
                              this.setState({ supplier: e.target.value })
                            }
                          />
                        )}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div
                      className={
                        JSON.parse(localStorage.getItem("UserData"))
                          .usertype === 3
                          ? "col-md-12 pt-3"
                          : "col-md-9 pt-3"
                      }
                    >
                      <Autocomplete
                        id="combo-box-demo"
                        variant="outlined"
                        size="small"
                        options={this.state.customerlist}
                        getOptionLabel={(option) => option.name}
                        value={this.state.customerobj}
                        onChange={(event, newValue) =>
                          this.setState({ customerobj: newValue })
                        }
                        InputProps={{
                          readOnly: this.state.isReadonly,
                        }}
                        fullWidth={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Customer"
                            variant="outlined"
                            onChange={(e) =>
                              this.setState({ customaer: e.target.value })
                            }
                          />
                        )}
                      />
                    </div>

                    {JSON.parse(localStorage.getItem("UserData")).usertype ===
                    3 ? (
                      ""
                    ) : (
                      <div className="col-md-3 pt-3">
                        <Button
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                          variant="contained"
                          onClick={addcustomer}
                        >
                          <Add />
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </div>

              <div className="col-md-7">
                <div className="row">
                  <div className="col-md-4">
                    <TextField
                      fullWidth={true}
                      label="Adults"
                      variant="outlined"
                      placeholder="Adults"
                      margin="normal"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                      }}
                      value={this.state.adult}
                      onChange={(e) => {
                        this.setState({ adult: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                    />
                  </div>

                  <div className="col-md-4">
                    <TextField
                      fullWidth={true}
                      label="Childs"
                      variant="outlined"
                      placeholder="Childs"
                      margin="normal"
                      name="motor_cable"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                      }}
                      value={this.state.kids}
                      onChange={(e) => {
                        this.setState({ kids: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                    />
                  </div>

                  <div className="col-md-4">
                    <TextField
                      fullWidth={true}
                      label="Infants"
                      variant="outlined"
                      placeholder="infants"
                      margin="normal"
                      name="motor_cable"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                      }}
                      value={this.state.infants}
                      onChange={(e) => {
                        this.setState({ infants: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-5">
                {this.state.type === 2 ? (
                  <div className="row">
                    <div className="col-md-12 pt-3">
                      <Autocomplete
                        id="combo-box-demo"
                        variant="outlined"
                        size="small"
                        options={this.state.customerlist}
                        getOptionLabel={(option) => option.name}
                        value={this.state.customerobj}
                        onChange={(event, newValue) =>
                          this.setState({ customerobj: newValue })
                        }
                        InputProps={{
                          readOnly: this.state.isReadonly,
                        }}
                        fullWidth={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Customer"
                            variant="outlined"
                            onChange={(e) =>
                              this.setState({ customaer: e.target.value })
                            }
                          />
                        )}
                      />
                    </div>
                  </div>
                ) : (
                  <div className="row">
                    <div
                      className={
                        JSON.parse(localStorage.getItem("UserData"))
                          .usertype === 3
                          ? "col-md-12 pt-3"
                          : "col-md-9 pt-3"
                      }
                    >
                      <Autocomplete
                        id="combo-box-demo"
                        variant="outlined"
                        size="small"
                        options={this.state.supplierList}
                        getOptionLabel={(option) => option.name}
                        value={this.state.supplierobj}
                        onChange={(event, newValue) =>
                          this.setState({ supplierobj: newValue })
                        }
                        fullWidth={true}
                        InputProps={{
                          readOnly: this.state.isReadonly,
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Supplier"
                            variant="outlined"
                            onChange={(e) =>
                              this.setState({ supplier: e.target.value })
                            }
                          />
                        )}
                      />
                    </div>
                    {JSON.parse(localStorage.getItem("UserData")).usertype ===
                    3 ? (
                      ""
                    ) : (
                      <div className="col-md-3 pt-3">
                        <Button
                          color="primary"
                          aria-label="upload picture"
                          component="span"
                          variant="contained"
                          onClick={addSupplier}
                        >
                          <Add />
                        </Button>
                      </div>
                    )}
                  </div>
                )}
              </div>
              <div className="col-md-7">
                <div className="row">
                  <div className="col-md-4">
                    <TextField
                      fullWidth={true}
                      label="Adult-Purchase"
                      variant="outlined"
                      placeholder="Purchase"
                      margin="normal"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={this.state.adlPurchase}
                      onChange={(e) => {
                        this.setState({ adlPurchase: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                        endAdornment: (
                          <InputAdornment position="end">
                            {this.state.currency}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div className="col-md-4">
                    <TextField
                      fullWidth={true}
                      label="Child-Purchase"
                      variant="outlined"
                      placeholder="Purchase"
                      margin="normal"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={this.state.kidPurchase}
                      onChange={(e) => {
                        this.setState({ kidPurchase: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                        endAdornment: (
                          <InputAdornment position="end">
                            {this.state.currency}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div className="col-md-4">
                    <TextField
                      fullWidth={true}
                      label="Infant-Purchase"
                      variant="outlined"
                      placeholder="Purchase"
                      margin="normal"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={this.state.infPurchase}
                      onChange={(e) => {
                        this.setState({ infPurchase: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                        endAdornment: (
                          <InputAdornment position="end">
                            {this.state.currency}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row mt-4">
              <div className="col-md-5">
                <div className="row">
                  <div className="col-md-6">
                    <TextField
                      fullWidth={true}
                      label="Discount"
                      variant="outlined"
                      placeholder="Discount"
                      margin="normal"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={this.state.discount}
                      onChange={(e) => {
                        this.setState({ discount: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                        endAdornment: (
                          <InputAdornment position="end">
                            {this.state.currency}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    <TextField
                      fullWidth={true}
                      label="Extra"
                      variant="outlined"
                      placeholder="Extra"
                      margin="normal"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={this.state.extra}
                      onChange={(e) => {
                        this.setState({ extra: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                        endAdornment: (
                          <InputAdornment position="end">
                            {this.state.currency}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md-7">
                <div className="row">
                  <div className="col-md-4">
                    <TextField
                      fullWidth={true}
                      label="Adult-Sell"
                      variant="outlined"
                      placeholder="Sell"
                      margin="normal"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={this.state.adlSell}
                      onChange={(e) => {
                        this.setState({ adlSell: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                        endAdornment: (
                          <InputAdornment position="end">
                            {this.state.currency}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div className="col-md-4">
                    <TextField
                      fullWidth={true}
                      label="Child-Sell"
                      variant="outlined"
                      placeholder="Sell"
                      margin="normal"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={this.state.kidSell}
                      onChange={(e) => {
                        this.setState({ kidSell: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                        endAdornment: (
                          <InputAdornment position="end">
                            {this.state.currency}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div className="col-md-4">
                    <TextField
                      fullWidth={true}
                      label="Infant-Sell"
                      variant="outlined"
                      placeholder="Sell"
                      margin="normal"
                      type="number"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      value={this.state.infSell}
                      onChange={(e) => {
                        this.setState({ infSell: e.target.value }, () => {
                          countTotal();
                        });
                      }}
                      InputProps={{
                        readOnly: this.state.isReadonly,
                        endAdornment: (
                          <InputAdornment position="end">
                            {this.state.currency}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-md-5">
                <div className="row">
                  <div className="col-md-6">
                    <TextField
                      fullWidth={true}
                      label="Commission"
                      value={this.state.commission}
                      variant="outlined"
                      placeholder="Commission"
                      margin="normal"
                      type="text"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      InputProps={{
                        readOnly: true,
                        endAdornment: (
                          <InputAdornment position="end">
                            {this.state.currency}
                          </InputAdornment>
                        ),
                      }}
                    />
                  </div>

                  <div className="col-md-6">
                    {this.state.type === 1 ? (
                      <TextField
                        fullWidth={true}
                        label="Paid"
                        variant="outlined"
                        placeholder="Paid"
                        margin="normal"
                        name="motor_cable"
                        type="number"
                        size="small"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={this.state.paid}
                        onChange={(e) =>
                          this.setState({ paid: e.target.value })
                        }
                        InputProps={{
                          readOnly: this.state.isReadonly,
                          endAdornment: (
                            <InputAdornment position="end">
                              {this.state.currency}
                            </InputAdornment>
                          ),
                        }}
                      />
                    ) : (
                      <TextField
                        fullWidth={true}
                        label="C.B"
                        variant="outlined"
                        placeholder="C.B"
                        margin="normal"
                        type="number"
                        size="small"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={this.state.cb}
                        onChange={(e) => this.setState({ cb: e.target.value })}
                        InputProps={{
                          readOnly: this.state.isReadonly,
                          endAdornment: (
                            <InputAdornment position="end">
                              {this.state.currency}
                            </InputAdornment>
                          ),
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="row">
                  {this.state.type === 2 ? (
                    <div className="col-md-6">
                      <TextField
                        fullWidth={true}
                        label="S.C.C"
                        variant="outlined"
                        placeholder="S.C.C"
                        margin="normal"
                        type="number"
                        size="small"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={this.state.scc}
                        onChange={(e) => this.setState({ scc: e.target.value })}
                        InputProps={{
                          readOnly: this.state.isReadonly,
                          endAdornment: (
                            <InputAdornment position="end">
                              {this.state.currency}
                            </InputAdornment>
                          ),
                        }}
                      />
                    </div>
                  ) : (
                    ""
                  )}
                  <div className="col-md-6">
                    <h2 className="mt-4 ml-3">
                      <b>
                        Total: {this.state.total} {this.state.currency}{" "}
                      </b>
                    </h2>
                  </div>
                </div>
              </div>
            </div>

            <div className="row pl-3 pr-3">
              <TextField
                fullWidth={true}
                multiline={true}
                label="Remarks"
                variant="outlined"
                placeholder="Remarks"
                margin="normal"
                name="motor_cable"
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  readOnly: this.state.isReadonly,
                }}
                value={this.state.remark}
                onChange={(e) => this.setState({ remark: e.target.value })}
              />
            </div>

            <div className="row mt-4">
              <div className="col-md-7 mt-2 pl-0 pr-0">
                <Dropzone onDrop={this.onDrop}>
                  {({ getRootProps, getInputProps }) => (
                    <section className="container">
                      <div {...getRootProps({ className: "dropzone" })}>
                        <input {...getInputProps()} />
                        <p>
                          Drag 'n' drop some files here, or click to select
                          files
                        </p>
                      </div>
                      <aside>
                        <h4>New Files</h4>
                        <ul>{files}</ul>
                        <hr />
                        <h4>Previous Files</h4>
                        {this.state.editedFile.map((value, index) => (
                          <a
                            href={`${axios.defaults.baseURL}files/${value.orige_name}`}
                            download
                          >
                            <IconButton
                              aria-label="delete"
                              disabled
                              color="primary"
                            >
                              <GetAppIcon />
                            </IconButton>
                          </a>
                        ))}
                      </aside>
                    </section>
                  )}
                </Dropzone>
              </div>
              <div className="col-md-5">
                <Button
                  color="primary"
                  variant="contained"
                  className="mt-2 form-control"
                  style={{ height: "74px" }}
                  type="submit"
                  disabled={this.state.isReadonly}
                >
                  Submit
                </Button>
              </div>
            </div>
          </form>
        </CustomScrollbars>
      </div>
    );
  };

  AppUsersInfo = () => {
    return (
      <div className="chat-sidenav-main">
        <div className="bg-grey lighten-5 chat-sidenav-header">
          <div className="chat-user-hd mb-0">
            <IconButton
              className="back-to-chats-button"
              aria-label="back button"
              onClick={() => {
                this.setState({
                  userState: 1,
                });
              }}
            >
              <i className="zmdi zmdi-arrow-back" />
            </IconButton>
          </div>
          <div className="chat-user chat-user-center">
            <div className="chat-avatar mx-auto">
              <img
                src="https://via.placeholder.com/150x150"
                className="avatar avatar-shadow rounded-circle size-60 huge"
                alt="John Doe"
              />
            </div>
            <div className="user-name h4 my-2">Mahdi Naseri</div>
          </div>
        </div>
        <div className="chat-sidenav-content">
          <CustomScrollbars
            className="chat-sidenav-scroll scrollbar"
            style={{
              height:
                this.props.width >= 1200
                  ? "calc(100vh - 328px)"
                  : "calc(100vh - 162px)",
            }}
          >
            <form className="p-4">
              <div className="form-group mt-4">
                <label>Mood</label>

                <Input
                  fullWidth={true}
                  id="exampleTextarea"
                  multiline
                  rows={3}
                  onKeyUp={this._handleKeyPress.bind(this)}
                  onChange={this.updateMessageValue.bind(this)}
                  defaultValue="it's a status....not your diary..."
                  placeholder="Status"
                  margin="none"
                />
              </div>
            </form>
          </CustomScrollbars>
        </div>
      </div>
    );
  };

  ChatUsers = () => {
    const addnewsell = (id) => {
      this.setState({ anchorEl: null });
      const data = {
        user_id: JSON.parse(localStorage.getItem("UserData")).id,
        type: id,
      };
      this.setState({ openbackdrop: true });
      axios
        .post("api/sale", data)
        .then((res) => {
          if (id === 1) {
            this.setState({ url: "api/getsale" });
            this.getSales();
          } else {
            this.setState({ refurl: "api/getrefund" });
            this.getRefund();
          }
          this.setState({ openbackdrop: false });
          NotificationManager.success(
            "New Sell Created successfully",
            <IntlMessages id="notification.titleHere" />
          );
        })
        .catch((err) => {
          this.setState({ openbackdrop: false });
          NotificationManager.error(
            <IntlMessages id="notification.errorMessage" />,
            <IntlMessages id="notification.titleHere" />
          );
        });
    };

    const handleClick = (event) => {
      //setAnchorEl(null);
      this.setState({
        anchorEl: event.currentTarget,
      });
    };

    const handleClose = () => {
      this.setState({
        anchorEl: null,
      });
    };

    const handleClickFilter = (event) => {
      //setAnchorEl(event.currentTarget);
      this.setState({
        anchorElFilter: event.currentTarget,
      });
    };

    const handleCloseFilter = () => {
      this.setState({
        anchorElFilter: null,
      });
    };

    const filterByUser = () => {
      const searchData = {
        serarchkey: this.state.userobj,
        user: JSON.parse(localStorage.getItem("UserData")).id,
        usertype: JSON.parse(localStorage.getItem("UserData")).usertype,
        searchby: this.state.selectedTabIndex,
      };

      this.setState({ openbackdrop: true });
      axios
        .post("api/filterbyUser", searchData)
        .then((res) => {
          this.setState({ openbackdrop: false });
          if (this.state.selectedTabIndex === 0) {
            this.setState({ saleslist: res.data });
          } else {
            this.setState({ refundlist: res.data });
          }
        })
        .catch((err) => {
          this.setState({ openbackdrop: false });
          NotificationManager.error(
            <IntlMessages id="notification.errorMessage" />,
            "can not load Customer"
          );
        });
    };

    const filterByDate = () => {
      const searchData = {
        startDate: this.state.startDate,
        endDate: this.state.endDate,
        user: JSON.parse(localStorage.getItem("UserData")).id,
        usertype: JSON.parse(localStorage.getItem("UserData")).usertype,
        searchby: this.state.selectedTabIndex,
      };

      this.setState({ openbackdrop: true });
      axios
        .post("api/filterbyDate", searchData)
        .then((res) => {
          this.setState({ openbackdrop: false });
          if (this.state.selectedTabIndex === 0) {
            this.setState({ saleslist: res.data });
          } else {
            this.setState({ refundlist: res.data });
          }
        })
        .catch((err) => {
          this.setState({ openbackdrop: false });
          NotificationManager.error(
            <IntlMessages id="notification.errorMessage" />,
            "can not load Customer"
          );
        });
    };

    return (
      <div className="chat-sidenav-main">
        <div className="chat-sidenav-header">
          <div className="row mb-5">
            <span className="col-md-2 p-0 ml-2">
              <div className="chat-avatar">
                <div className="chat-avatar-mode">
                  <img
                    id="user-avatar-button"
                    src={`${axios.defaults.baseURL}userimage/${
                      JSON.parse(localStorage.getItem("UserData")).image
                    }`}
                    className="rounded-circle size-50"
                    alt=""
                  />
                  <span className="chat-mode online" />
                </div>
              </div>
            </span>

            <span className="col-md-5 p-0 ml-2">
              <h5 className="mt-3 white-color">
                {JSON.parse(localStorage.getItem("UserData")).name}
              </h5>
            </span>

            <span className="col-md-4 p-0">
              <span>
                <IconButton
                  aria-label="Add New Sell"
                  className="white-apply"
                  onClick={() => {
                    addnewsell(1);
                  }}
                  style={{ display: "inline" }}
                >
                  <AddIcon />
                </IconButton>
              </span>

              <span className=" p-0">
                <IconButton
                  color="white-color"
                  className="white-apply"
                  onClick={handleClick}
                  style={{ display: "inline" }}
                >
                  <MoreVertIcon />
                </IconButton>

                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  keepMounted
                  open={Boolean(this.state.anchorEl)}
                  onClose={handleClose}
                >
                  <MenuItem
                    onClick={() => {
                      addnewsell(2);
                    }}
                  >
                    Refund
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.setState({ userDialog: true, anchorEl: null });
                    }}
                  >
                    User Managment
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      this.setState({ cutomerDialog: true, anchorEl: null });
                    }}
                  >
                    Data Managment
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      localStorage.removeItem("token");
                      localStorage.removeItem("UserData");
                      this.props.history.push("/signin");
                    }}
                  >
                    Logout
                  </MenuItem>
                </Menu>

                <Cutomer
                  changeCutomer={this.changeCutomer.bind(this)}
                  customeropen={this.state.cutomerDialog}
                  setRefundOpen={this.state.cutomerDialog}
                />
              </span>
            </span>
          </div>

          <User
            changeUserDeialog={this.changeUserDeialog.bind(this)}
            open={this.state.userDialog}
          />

          <div className="search-wrapper" style={{ marginRight: "0px" }}>
            <div className="row">
              <div className="col-md-9 pr-2 serarchboxstyle">
                <SearchBox
                  placeholder="Search in Tickets"
                  onChange={this.updateSearchChatUser.bind(this)}
                  value={this.state.searinchticket}
                />
              </div>
              <div className="col-md-3 pl-0 pr-0">
                <IconButton
                  aria-label="Add New Sell"
                  className="white-apply"
                  onClick={handleClickFilter}
                >
                  <FilterListIcon />
                </IconButton>

                <Menu
                  id="simple-filter"
                  anchorEl={this.state.anchorElFilter}
                  keepMounted
                  open={Boolean(this.state.anchorElFilter)}
                  onClose={handleCloseFilter}
                >
                  {JSON.parse(localStorage.getItem("UserData")).usertype !==
                  3 ? (
                    <>
                      <strong className="mb-3">Based on User</strong>
                      <div className="row mt-3">
                        <div className="col-md-8">
                          <Autocomplete
                            id="combo-box-demo"
                            variant="outlined"
                            size="small"
                            options={this.state.userlist}
                            getOptionLabel={(option) => option.name}
                            value={this.state.userobj}
                            onChange={(event, newValue) =>
                              this.setState({ userobj: newValue })
                            }
                            fullWidth={true}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select User"
                                variant="outlined"
                              />
                            )}
                          />
                        </div>
                        <div className="col-md-4">
                          <Button
                            variant="contained"
                            color="primary"
                            onClick={filterByUser}
                          >
                            <SearchIcon />
                          </Button>
                        </div>
                      </div>
                      <Divider className="m-3" />
                    </>
                  ) : (
                    ""
                  )}

                  <strong className="mb-3">Based on Date</strong>
                  <div className="row">
                    <div className="col-md-6 pr-1">
                      <TextField
                        fullWidth={true}
                        label="Date"
                        type="date"
                        variant="outlined"
                        margin="normal"
                        size="small"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) =>
                          this.setState({ startDate: e.target.value })
                        }
                      />
                    </div>
                    <div className="col-md-6 pl-1">
                      <TextField
                        fullWidth={true}
                        label="Date"
                        type="date"
                        variant="outlined"
                        margin="normal"
                        size="small"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        onChange={(e) =>
                          this.setState({ endDate: e.target.value })
                        }
                      />
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-8"></div>
                    <div className="col-md-4">
                      <Button
                        variant="contained"
                        color="primary"
                        className="float-right mr-3"
                        onClick={filterByDate}
                      >
                        <SearchIcon />
                      </Button>
                    </div>
                  </div>
                </Menu>
              </div>
            </div>
          </div>
        </div>

        <div className="chat-sidenav-content">
          <AppBar position="static" className="no-shadow chat-tabs-header">
            <Tabs
              className="chat-tabs"
              value={this.state.selectedTabIndex}
              onChange={this.handleChange}
              indicatorColor="primary"
              textColor="primary"
              variant="fullWidth"
            >
              <Tab label={"Sales List"} />
              <Tab label={"Refund"} />
            </Tabs>
          </AppBar>

          <SwipeableViews
            index={this.state.selectedTabIndex}
            onChangeIndex={this.handleChangeIndex}
          >
            <CustomScrollbars
              className="chat-sidenav-scroll scrollbar"
              style={{
                height:
                  this.props.width >= 1200
                    ? "calc(100vh - 230px)"
                    : "calc(100vh - 202px)",
              }}
            >
              {this.state.saleLoader || this.state.firstload ? (
                <div
                  className="loader-view w-100"
                  style={{ height: "calc(50vh - 120px)" }}
                >
                  <CircularProgress />
                </div>
              ) : this.state.saleslist.length === 0 ? (
                <div className="p-5">{this.state.userNotFound}</div>
              ) : (
                <ChatUserList
                  saleslist={this.state.saleslist}
                  selectedSectionId={this.state.selectedSectionId}
                  onSelectUser={this.onSelectUser.bind(this)}
                />
              )}

              {this.state.saleslist.length > 19 ? (
                <Button
                  onClick={this.loadMore.bind(this)}
                  color="primary"
                  className="float-right"
                >
                  Load More
                </Button>
              ) : (
                ""
              )}
            </CustomScrollbars>

            <CustomScrollbars
              className="chat-sidenav-scroll scrollbar"
              style={{
                height:
                  this.props.width >= 1200
                    ? "calc(100vh - 230px)"
                    : "calc(100vh - 202px)",
              }}
            >
              {this.state.refundLoader ? (
                <div
                  className="loader-view w-100"
                  style={{ height: "calc(100vh - 120px)" }}
                >
                  <CircularProgress />
                </div>
              ) : (
                ""
              )}

              {this.state.refundlist.length === 0 ? (
                <div className="p-5">No Refund Exist !</div>
              ) : (
                <ChatUserList
                  saleslist={this.state.refundlist}
                  selectedSectionId={this.state.selectedSectionId}
                  onSelectUser={this.onSelectUser.bind(this)}
                />
              )}

              {this.state.refundlist.length > 19 ? (
                <Button
                  onClick={this.loadMoreRefund.bind(this)}
                  color="primary"
                  className="float-right"
                >
                  Load More
                </Button>
              ) : (
                ""
              )}
            </CustomScrollbars>
          </SwipeableViews>
        </div>
      </div>
    );
  };

  handleChange = (event, value) => {
    this.setState({ selectedTabIndex: value });
  };

  handleChangeIndex = (index) => {
    this.setState({ selectedTabIndex: index });
  };

  onSelectUser = (user) => {
    this.setState({
      loader: true,
      selectedSectionId: user.id,
      drawerState: this.props.drawerState,
      selectedUser: user,
      conversation: this.state.conversationList.find(
        (data) => data.id === user.id
      ),
      curentSell: user,
      isReadonly: user.customer !== null ? true : false,

      provepay: user.payprove,
      editsale: user.edit[0]?.status === 1 ? 1 : 0,
      editID: user.edit[0]?.id,
      editstatus: user.edit[0]?.status,
      adult: user.adults,
      kids: user.kids,
      infants: user.infants,
      adlPurchase: user.adlPurchase,
      kidPurchase: user.kidPurchase,
      infPurchase: user.infPurchase,
      adlSell: user.adlSell,
      kidSell: user.kidSell,
      infSell: user.infSell,
      discount: user.discount,
      commission: user.commission,
      extra: user.extra === null ? 0 : user.extra,
      paid: user.paid,
      cb: user.cb,
      scc: user.scc,
      type: user.type,
      remark: user.remark,
      currency: user.currency,
      selectedDate: user.datetime !== null ? user.datetime : new Date(),
      customerobj: user.customer,
      supplierobj: user.supplier,
      editedFile: user.sale_file,
      total: user.total,
    });
    setTimeout(() => {
      this.setState({ loader: false });
    }, 1000);
  };
  showCommunication = () => {
    return (
      <div className="chat-box">
        <div className="chat-box-main">
          {this.state.selectedUser === null ? (
            <div
              className="loader-view"
              style={{ height: "calc(100vh - 120px)" }}
            >
              {/* <i className="zmdi zmdi-comment s-128 text-muted"/> */}
              {/* <i className="zmdi zmdi-flight-takeoff s-128 text-muted"/> */}
              <img
                id="user-avatar-button"
                src="/images/logo.png"
                className="text-muted imagelogostyle"
                alt=""
              />
              <h1 className="text-muted">
                {<IntlMessages id="chat.selectUserChat" />}
              </h1>
              <Button
                className="d-block d-xl-none"
                color="primary"
                variant="contained"
                onClick={this.onToggleDrawer.bind(this)}
              >
                {<IntlMessages id="chat.selectContactChat" />}
              </Button>
            </div>
          ) : (
            this.Communication()
          )}
        </div>
      </div>
    );
  };

  constructor() {
    super();
    this.state = {
      refundLoader: false,
      saleLoader: false,
      isReadonly: false,
      loader: false,
      openbackdrop: false,
      userNotFound: "No sales found pleas add !",
      drawerState: false,
      selectedSectionId: "",
      selectedTabIndex: 0,
      userState: 1,
      searinchticket: "",
      contactList: users.filter((user) => !user.recent),
      selectedUser: null,
      message: "",
      chatUsers: users.filter((user) => user.recent),
      conversationList: conversationList,
      conversation: null,

      startDate: "",
      endDate: "",
      editsale: 0,
      editID: 0,
      editstatus: 3,

      userDialog: false,
      refundDialog: false,
      cutomerDialog: false,
      anchorEl: null,
      anchorElFilter: null,
      showspinner: false,

      provepay: 0,
      selectedDate: new Date(),
      customaer: "",
      customerobj: {},
      userobj: {},
      supplier: "",
      supplierobj: {},
      adult: 0,
      kids: 0,
      infants: 0,
      adlPurchase: 0,
      kidPurchase: 0,
      infPurchase: 0,
      adlSell: 0,
      kidSell: 0,
      infSell: 0,
      discount: 0,
      commission: 0,
      extra: 0,
      cb: 0,
      scc: 0,
      type: 1,
      paid: "",
      remark: "",
      currency: "USD",
      total: 0,
      files: [],
      base64files: [],
      editedFile: [],
      curentSell: {},

      firstload: true,
      saleslist: [],
      refundlist: [],
      customerlist: [],
      supplierList: [],
      userlist: [],
      url: "api/getsale",
      pagination: [],

      refurl: "api/getrefund",
      refundpagination: [],
    };

    this.getSales();
    this.getRefund();
    this.getCustomer();
    this.getSupplier();
    this.getUser();
    this.onDrop = (files) => {
      this.setState({ files });
    };
  }

  getSales() {
    this.fetchSale();
  }

  fetchSale() {
    const userData = {
      user_id: JSON.parse(localStorage.getItem("UserData")).id,
      usertype: JSON.parse(localStorage.getItem("UserData")).usertype,
      type: 1,
    };

    this.setState({ saleLoader: true });
    axios
      .post(this.state.url, userData)
      .then((res) => {
        this.setState({ saleLoader: false });
        this.setState({ firstload: false });

        this.setState({
          saleslist: res.data.data,
          url: res.data.next_page_url,
        });
        this.setState({ showspinner: false });

        this.makepagination(res.data);
      })
      .catch((err) => {
        this.setState({ saleLoader: false });
        this.setState({ showspinner: false });
        this.setState({ firstload: false });
        NotificationManager.error(
          <IntlMessages id="notification.errorMessage" />,
          <IntlMessages id="notification.titleHere" />
        );
      });
  }

  makepagination(data) {
    let pagination = {
      current_page: data.current_page,
      last_page: data.last_page,
      next_page_url: data.next_page_url,
      prev_page_url: data.prev_page_url,
    };

    this.setState({ pagination: pagination });
  }

  loadMore() {
    this.setState({ url: "api/getsale" });
    this.setState({ url: this.state.pagination.next_page_url });
    this.fetchSale();
  }

  loadMoreRefund() {
    this.setState({ refurl: "api/getrefund" });
    this.setState({ refurl: this.state.refundpagination.next_page_url });
    this.fetchRefund();
  }
  makepaginationrefund(data) {
    let paginationref = {
      current_page: data.current_page,
      last_page: data.last_page,
      next_page_url: data.next_page_url,
      prev_page_url: data.prev_page_url,
    };

    this.setState({ refundpagination: paginationref });
  }

  getRefund() {
    this.fetchRefund();
  }

  fetchRefund() {
    const userData = {
      user_id: JSON.parse(localStorage.getItem("UserData")).id,
      usertype: JSON.parse(localStorage.getItem("UserData")).usertype,
      type: 2,
    };
    this.setState({ refundLoader: true });
    axios
      .post(this.state.refurl, userData)
      .then((res) => {
        this.setState({ refundlist: res.data.data });
        this.setState({ refundLoader: false });
        this.setState({
          refundlist: res.data.data,
          refurl: res.data.next_page_url,
        });

        this.makepaginationrefund(res.data);
      })
      .catch((err) => {
        this.setState({ refundLoader: false });
        NotificationManager.error(
          <IntlMessages id="notification.errorMessage" />,
          <IntlMessages id="notification.titleHere" />
        );
      });
  }

  getCustomer() {
    axios
      .get("api/customer")
      .then((res) => {
        this.setState({ customerlist: res.data });
      })
      .catch((err) => {
        NotificationManager.error(
          <IntlMessages id="notification.errorMessage" />,
          "can not load Customer"
        );
      });
  }

  getUser() {
    axios
      .get("api/user")
      .then((res) => {
        this.setState({ userlist: res.data });
      })
      .catch((err) => {
        NotificationManager.error(
          <IntlMessages id="notification.errorMessage" />,
          "can not load Customer"
        );
      });
  }

  getSupplier() {
    axios
      .get("api/supplier")
      .then((res) => {
        this.setState({ supplierList: res.data });
      })
      .catch((err) => {
        NotificationManager.error(
          <IntlMessages id="notification.errorMessage" />,
          "can not load Customer"
        );
      });
  }

  updateMessageValue(evt) {
    this.setState({
      message: evt.target.value,
    });
  }

  updateSearchChatUser(evt) {
    this.setState({
      searinchticket: evt.target.value,
    });

    this.serarch();
  }

  serarch = debounce(() => {
    const searchData = {
      serarchkey: this.state.searinchticket,
      user: JSON.parse(localStorage.getItem("UserData")).id,
      usertype: JSON.parse(localStorage.getItem("UserData")).usertype,
      searchby: this.state.selectedTabIndex,
    };
    axios
      .post("api/findtickit", searchData)
      .then((res) => {
        if (this.state.selectedTabIndex === 0) {
          this.setState({ saleslist: res.data });
        } else {
          this.setState({ refundlist: res.data });
        }
      })
      .catch((err) => {
        NotificationManager.error(
          <IntlMessages id="notification.errorMessage" />,
          "can not load Customer"
        );
      });
  }, 2000);

  onToggleDrawer() {
    this.setState({
      drawerState: !this.state.drawerState,
    });
  }

  customfunction() {
    this.setState({
      refundDialog: false,
    });
  }

  changeRefund() {
    this.setState({
      refundDialog: false,
    });
  }

  changeCutomer() {
    this.setState({
      cutomerDialog: false,
    });
  }

  changeUserDeialog() {
    this.setState({
      userDialog: false,
    });
  }

  render() {
    const { classes } = this.props;
    const { loader, userState, drawerState } = this.state;

    return (
      <>
        <Backdrop className={classes.backdrop} open={this.state.openbackdrop}>
          <CircularProgress color="inherit" />
        </Backdrop>

        <div className="app-wrapper app-wrapper-module">
          <div className="app-module chat-module animated slideInUpTiny animation-duration-3">
            <div className="chat-module-box">
              <div className="d-block d-xl-none">
                <Drawer
                  open={drawerState}
                  onClose={this.onToggleDrawer.bind(this)}
                >
                  {userState === 1 ? this.ChatUsers() : this.AppUsersInfo()}
                </Drawer>
              </div>
              <div className="chat-sidenav d-none d-xl-flex">
                {userState === 1 ? this.ChatUsers() : this.AppUsersInfo()}
              </div>
              {loader ? (
                <div
                  className="loader-view w-100"
                  style={{ height: "calc(100vh - 120px)" }}
                >
                  <CircularProgress />
                </div>
              ) : (
                this.showCommunication()
              )}
            </div>
          </div>
        </div>
        <NotificationContainer />
      </>
    );
  }
}

const mapStateToProps = ({ settings }) => {
  const { width } = settings;

  return { width };
};

export default withStyles(styles)(connect(mapStateToProps)(ChatPanel));
